import { CircularProgress } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { BOOKING_STAGES } from '../../../constants';
import { adminUpdateBooking } from '../../../services/apiService';
import { CustomContext } from '../page';

export default function RescheduleSession({ booking, refreshData }) {
  const [isLoading, setIsLoading] = useState(false);
  const { setSelectedAction } = useContext(CustomContext);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);
      const payload = {
        id: booking.id,
        stage: BOOKING_STAGES.CREATED.value,
        coachId: null,
        startTime: null,
        endTime: null,
        problemReportedByStudent: false,
        problemReportedByCoach: false,
      };
      await adminUpdateBooking(payload);
      setSelectedAction(null);
      toast.success('Session rescheduled');
      refreshData();
    } catch (err) {
      console.error(err);
      toast.error('Failed to reschedule!');
    }
  };

  return (
    <div className='fixed inset-0 bg-black bg-opacity-80 flex'>
      <div className='m-auto w-full max-w-2xl bg-white rounded p-5 relative'>
        <h6 className='text-lg opacity-80'>
          Are you sure you want to reschedule this session?
        </h6>

        <button
          onClick={() => setSelectedAction(null)}
          className='absolute top-4 right-4'
        >
          <Close />
        </button>

        <button
          onClick={handleSubmit}
          disabled={isLoading}
          className='bg-green-c1 text-white rounded w-48 py-1 mt-6 ml-auto flex justify-center'
        >
          {isLoading ? (
            <CircularProgress color='inherit' size='1.5rem' />
          ) : (
            <span>Reschedule</span>
          )}
        </button>
      </div>
    </div>
  );
}
